import ChoicesSelect from '@/js/components/Forms/Inputs/ChoicesSelect.js';

export default class FormSelect {
  init() {
    this.selectForms = Array.from(document.querySelectorAll('.wpcf7-select'));

    if (!this.selectForms.length) {
      return;
    }

    this.selectForms.forEach((selectForm) => {
      this.initChoices(selectForm);
    });
  }

  initChoices(form) {
    new ChoicesSelect(form, { multiple: false });

    /*const multipleChoicesElements = Array.from(
        form.querySelectorAll('.site-filter__input--choices')
    );

    for (const multipleChoicesElement of multipleChoicesElements) {
      new ChoicesSelect(multipleChoicesElement, { multiple: true });
    }

    const simpleChoicesElements = Array.from(
        form.querySelectorAll('.site-filter__input--select')
    );

    for (const multipleChoicesElement of simpleChoicesElements) {
      new ChoicesSelect(multipleChoicesElement, { multiple: false });
    } */
  }
}
